import React from "react";
import { GiPill } from "react-icons/gi";
import { HiOutlineSpeakerphone } from "react-icons/hi";
import { RiSearchLine, RiLogoutCircleLine } from "react-icons/ri";
import { TbClipboardList, TbMicroscope, TbSettings } from "react-icons/tb";
import { Link, useNavigate } from "react-router-dom";
import { useReduxSelector } from "../redux/hooks";
import { resetUser } from "../redux/slice/UserSlice";
import { useDispatch } from "react-redux";

export default function Sidebar({ pathname, handleOpen }: any) {
  const navigate = useNavigate();
  const { isSignedIn } = useReduxSelector((state) => state.user);
  const dispatch = useDispatch();

  const handleLogout = () => {
    dispatch(resetUser());
    // Small delay to ensure state is updated before redirect
    setTimeout(() => {
      window.location.href = '/signin';
    }, 100);
  };

  return (
    <div className="border-r border-[#E8E8E8] w-[240px] shadow-lg font-montserrat hidden lg:flex flex-col h-full m-0 p-0">
      {/* Top side navbar content */}
      <div className="flex-1 pt-6 px-6">
        <img
          src="/assets/trust-hospital-logo.png"
          alt="Trust hospital logo"
          width={180}
          className="mb-6 cursor-pointer"
          onClick={() => navigate("/")}
        />
        <div className="space-y-1">
          {isSignedIn && (
            <>
              <Link
                to={"/find-a-doctor"}
                className={`flex items-center space-x-3 transition-colors duration-200 ${pathname === "/find-a-doctor"
                  ? "bg-[#BBDAF7] hover:opacity-80"
                  : "hover:bg-slate-50 text-[#8E8E8E] bg-none"
                  } p-3 rounded-3xl font-medium text-sm hover:cursor-pointer`}
              >
                <RiSearchLine className="text-xl" />
                <p>Find a doctor</p>
              </Link>
              <Link
                to={"/visits-and-appointments"}
                className={`flex items-center space-x-3 transition-colors duration-200 ${pathname === "/visits-and-appointments"
                  ? "bg-[#BBDAF7] hover:opacity-80"
                  : "hover:bg-slate-50 text-[#8E8E8E] bg-none"
                  } p-3 rounded-3xl font-medium text-sm hover:cursor-pointer`}
              >
                <TbClipboardList className="text-xl" />
                <p>Visits & Appointments</p>
              </Link>
              <Link
                to={"/lab-investigations"}
                className={`flex items-center space-x-3 transition-colors duration-200 ${pathname === "/lab-investigations"
                  ? "bg-[#BBDAF7] hover:opacity-80"
                  : "hover:bg-slate-50 text-[#8E8E8E] bg-none"
                  } p-3 rounded-3xl font-medium text-sm hover:cursor-pointer`}
              >
                <TbMicroscope className="text-xl" />
                <p>Lab Investigations</p>
              </Link>
              <Link
                to={"/prescriptions"}
                className={`flex items-center space-x-3 transition-colors duration-200 ${pathname === "/prescriptions"
                  ? "bg-[#BBDAF7] hover:opacity-80"
                  : "hover:bg-slate-50 text-[#8E8E8E] bg-none"
                  } p-3 rounded-3xl font-medium text-sm hover:cursor-pointer`}
              >
                <GiPill className="text-xl" />
                <p>Prescriptions</p>
              </Link>
            </>
          )}
        </div>
      </div>
      {/* Bottom side navbar content */}
      {isSignedIn && (
        <div className="border-t border-[#E8E8E8] px-6 py-4 space-y-2">
          <Link
            to="/settings"
            className={`flex items-center text-[#8E8E8E] space-x-3 p-3 rounded-3xl font-medium text-sm hover:cursor-pointer hover:bg-[#BBDAF7] w-full transition-all duration-300 ${pathname === "/settings" ? "bg-[#BBDAF7]" : ""
              }`}
          >
            <TbSettings className="text-xl" />
            <p>Settings</p>
          </Link>
          <button
            onClick={handleOpen}
            className="flex items-center text-[#8E8E8E] space-x-3 p-3 rounded-3xl font-medium text-sm hover:cursor-pointer hover:bg-[#BBDAF7] w-full transition-all duration-300"
          >
            <RiLogoutCircleLine className="text-xl" />
            <div>Log Out</div>
          </button>
        </div>
      )}
    </div>
  );
}
